<!--Navigation starts here-->
<div id="header-nav-set">
  @if (isProfileVisible) {
  <div class="profile-switch">
    <app-profile-switch></app-profile-switch>
  </div>
  }
  <div id="header-top-row-r" class="hd-r-row">
    <div id="lang-set">
      <ul class="language-menu">
        <ng-container>
          <li class="lang-text active">
            <a (click)="openLanguageSelection()" id="language-text-link">
              <span class="desk-only desk-selected-lang">{{userLanguageForDisplay | titlecase}}</span>
              <span class="mob-only mob-selected-lang">{{userLanguageForDisplay | titlecase}}</span>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>

  <div id="header-bottom-row-r" class="hd-r-row">
    <div id="nav-main">
      <ul>

        <li>@if (_enableGoogleMaps) {
          <a [class.active]="isLocationsActive()" [routerLink]="['/'+selectedLanguage+'/locations']"
            (click)="toggleMobileMenu()">Locations</a>
          }
        </li>
        <li><a [routerLink]="['/'+selectedLanguage+'/events']" [class.active]="isEventsActive()"
            (click)="toggleMobileMenu()">{{commonLabels.EVENTS_TITLE| translate | uppercase}}</a></li>

        <li>
          <button id="user-profile" class="desk-only profile-btn" (click)="myProfile()" appClickOutside
            (clickOutside)="closeDialog($event)">
            <span [ngClass]="isProfileVisible?'border-red prof-image':'prof-image'">
              <img [src]="cacheBustedUrl" alt="">
            </span>

          </button>
        </li>

      </ul>
    </div>

  </div>



</div>
<!--Navigation Ends here-->